module.exports = __webpack_public_path__ + "850ab2ad26a77b3f37a9a2d72c2bd6dd.pdf";